/**
 * This file was automatically generated by @cosmwasm/ts-codegen@0.24.0.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run the @cosmwasm/ts-codegen generate command to regenerate this file.
 */

export interface InstantiateMsg {
  minter?: string | null;
  token_uri: string;
}
export type ExecuteMsg =
  | {
      mint: {
        to: string;
      };
    }
  | {
      set_minter: {
        minter: string;
      };
    };
export type QueryMsg =
  | {
      get_token_uri: {};
    }
  | {
      get_info: {};
    }
  | {
      get_soul_bound_token: {
        soul: string;
      };
    };
export type Addr = string;
export type Uint128 = string;
export interface GetInfoResponse {
  minter: Addr;
  owner: Addr;
  token_total: Uint128;
  token_uri: string;
}
export interface GetSoulBoundTokenResponse {
  token_id: Uint128;
}
export interface GetTokenURIResponse {
  token_uri: string;
}
export type CwSoulboundExecuteMsg = ExecuteMsg;
